
import { defineComponent, PropType, computed } from 'vue'
import JrInputView from '@/components/jr-parts/JrInputView.vue'

/**
 * ラベル設定
 */
export interface Label {
  value: string | number | boolean
  text: string
  disabled?: boolean
}

export default defineComponent({
  name: 'JrRadioGroup',
  emits: ['update:modelValue'],
  components: { JrInputView },
  props: {
    modelValue: {
      type: [String, Number, Boolean],
      required: false,
      default: null,
    },
    labels: {
      type: Array as PropType<Label[]>,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    radioClass: {
      type: String,
      required: false,
      default: '',
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
    },
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
    // 垂直配置するか
    vertical: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, context) {
    const selectLabel = computed(() => {
      return props.labels.find((label: Label) => {
        return label.value === props.modelValue
      })
    })
    return {
      props,
      selectLabel,
      update: (event: string | number | boolean) => {
        context.emit('update:modelValue', event)
      },
    }
  },
})

/**
 * 頻出ラベル 無し/有り
 */
export const availableLabels: Label[] = [
  { value: false, text: '無し' },
  { value: true, text: '有り' },
]
